import Commands from './commands';

class Return extends Commands {
    constructor(registry) {
        super("return", registry);
    }

    async execute(node, emitter, options) {
        return await emitter(node.params[0], options);
    }
}

export default Return;
